export const DOMICILIO_FISCAL = { ID: 1, CODIGO: '00' };